import { ProductDetailData } from "../../../../models/ProductDetailData"
import Nutrition from "./nutrition/Nutrition"
import Psychology from "./psychology/Psychology"

import "./Promotions.css"

type PromotionProps = {
  dietProducts: ProductDetailData[]
  psychologyProducts: ProductDetailData[]
  nutriDiscount?: number
  psychoDiscount?: number
}

export default function Promotions({
  dietProducts,
  psychologyProducts,
  nutriDiscount,
  psychoDiscount
}: PromotionProps) {
  return (
    <div>
      <Nutrition products={dietProducts} discount={nutriDiscount} />
      <Psychology products={psychologyProducts} discount={psychoDiscount} />
    </div>
  )
}
